import React from 'react';
import PropTypes from 'prop-types';
import { getDashboardMenuConfig } from '@constants/config';
import NameDescriptionDialog from '@shared/dialogs/name-description-dialog';
import TaskTypeDiscardDialog from '@shared/dialogs/task-type-discard-dialog';
import TaskTypePublishDialog from '@shared/dialogs/task-type-publish-dialog';
import SidebarSection from './sidebar-section';
import './admin-console.scss';

const AdminConsole = ({ children }) => {
  const menuConfig = getDashboardMenuConfig();
  const menuSections = Array.isArray(menuConfig) ? menuConfig : [];

  return (
    <div styleName="admin-console-container">
      <div styleName="admin-console-sidebar">
        {menuSections.map(section => <SidebarSection key={section.title} section={section} />)}
      </div>
      <div styleName="admin-console-body">
        {children}
      </div>
      <NameDescriptionDialog />
      <TaskTypeDiscardDialog />
      <TaskTypePublishDialog />
    </div>
  );
};

AdminConsole.propTypes = {
  children: PropTypes.element
};

export default AdminConsole;
